// extracted by mini-css-extract-plugin
export default {"phoenix":"index_phoenix_cLQL1","phoenix_wrap":"index_phoenix_wrap_U9Q4A","slide_container":"index_slide_container_75BsS"};